import { useQuery } from "@tanstack/react-query";
import axiosManager from "../../services/axiosManager";
import { getApiDomain } from "../../services/serviceConfig";

const useMiddlewareAuth = (accessTokenMsal) => {
    const headers = { Authorization: `Bearer ${accessTokenMsal}` };

    const {
        isLoading: callingFetchMiddleware,
        data: accessTokenMiddleware,
        error: userMiddlewareError,
        refetch: refetchUserToken,
    } = useQuery({
        queryKey: ["auth/api/accesstoken/parent", accessTokenMsal],
        queryFn: () => axiosManager.get$(`${getApiDomain()}/auth/api/accesstoken/parent`, { headers })
            .then((response) => response?.data?.access_token),
        retry: 0,
        enabled: !!accessTokenMsal,
    });

    return {
        callingFetchMiddleware,
        accessTokenMiddleware,
        userMiddlewareError,
        refetchUserToken,
    };
};

export default useMiddlewareAuth;
